module.exports = __webpack_public_path__ + "static/media/analyze.97485829.png";